export default {
    state: {
        gripSimpleMap: undefined,
        curOpenWin: undefined,
    },
    getters: {
        getGripSimpleMap(state) {
            return state.gripSimpleMap;
        },
        getCurOpenWin(state) {
            return state.curOpenWin;
        },
    },
    mutations: {
        GRIP_SIMPLE_MAP(state, gripSimpleMap) {
            state.gripSimpleMap = gripSimpleMap;
        },
        CUR_OPEN_WIN(state, curOpenWin) {
            state.curOpenWin = curOpenWin;
        },
    },
    actions: {
        SET_GRIP_SIMPLE_MAP({ commit }, gripSimpleMap) {
            commit('GRIP_SIMPLE_MAP', gripSimpleMap);
        },
        SET_CUR_OPEN_WIN({ commit }, curOpenWin) {
            commit('CUR_OPEN_WIN', curOpenWin);
        },
    },
};
